export function ArrowLeft() {
    return (
        <svg>
            <use xlinkHref="#arrow-left" />
        </svg>
    );
}
